import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaUserCircle } from 'react-icons/fa';

function MasterNavbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  let user = {};

  try {
    if (token) user = JSON.parse(atob(token)); // ✅ decode base64 token
  } catch {
    localStorage.removeItem('token');
    navigate('/master-login');
  }

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/master-login');
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm px-4 py-2">
      <div className="container-fluid">
        <span className="navbar-brand fw-bold text-primary fs-4">
          🛂 Visitor Management
        </span>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMenu"
          aria-controls="navbarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarMenu">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* Users Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Users
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="/users/show">Show</a></li>
              </ul>
            </li>

            {/* Distributors Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Distributors
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="/distributors/show">Show</a></li>
              </ul>
            </li>

            {/* Customers Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Customers
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="/customers/show">Show</a></li>
              </ul>
            </li>
          </ul>

          {/* Right side */}
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center text-dark">
              <FaUserCircle className="me-2 fs-5 text-secondary" />
              <span className="fw-semibold">{user.name || 'User'}</span>
            </div>

            <button
              className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
              onClick={handleLogout}
            >
              <FaSignOutAlt />
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default MasterNavbar;
